const config = {
	globalScope: 'gardenBagsBookings',
	frontendUri: process.env.FRONTEND_URI,
	apiUri: process.env.API_URI,
	reCaptchaKey: '6Ld4mS0UAAAAAPA8hS7l8hABCuYVMP7C39F06egU',
};

window[config.globalScope] = window[config.globalScope] || {};

export default config;
